import Vue from 'vue'
import BoutonDictee from '@/components/dictee/bouton-dictee.vue'
import { champsAvecBouton } from '@/utils/dictee'

// Dictée de rédaction : quand on clique dans une zone de texte qui n'a pas son propre bouton, le bouton
// « Démarrer la dictée vocale » apparaît au-dessus du champ, à droite. Aucune modification des écrans : un seul
// bouton flottant, posé sur la page, qui suit le champ actif.

const CHAMPS = 'textarea, input[type="text"], input:not([type]), .ql-editor, [contenteditable="true"]'

function plusProche(el, selecteur) {
    for (let n = el; n && n.nodeType === 1; n = n.parentNode) if (n.matches && n.matches(selecteur)) return n
    return null
}

export function champEligible(el) {
    if (!el || el.nodeType !== 1 || !el.matches || !el.matches(CHAMPS)) return false
    if (el.disabled || el.readOnly) return false
    if (plusProche(el, '[data-dictee="non"], [data-dictee="dedie"], .multiselect, .vue-tel-input, .bouton-dictee, .login-page, .ql-disabled, [contenteditable="false"]')) return false
    // Les montants sont souvent des input text avec inputmode numeric : le type seul ne suffit pas.
    if (/^(numeric|decimal|tel|email|url|search)$/.test(String(el.getAttribute('inputmode') || '').toLowerCase())) return false
    // Pas de dictée automatique sur un champ court (référence, identité, prix, filtre…).
    // Un véritable champ de rédaction sur une ligne peut être déclaré explicitement.
    if (el.tagName === 'INPUT' && el.getAttribute('data-dictee') !== 'texte') return false
    const conteneur = plusProche(el, '.ql-container')
    const id = (conteneur && conteneur.id) || el.id
    if (id && champsAvecBouton.has(id)) return false
    // Champ qui a déjà son bouton de dictée dans son bloc (synthèse, certificat, anamnèse…).
    const bloc = plusProche(el, '.form-group, [class^="col-"], [class*=" col-"]')
    if (bloc && bloc.querySelector && bloc.querySelector('.dictation-button')) {
        const autre = plusProche(bloc.querySelector('.dictation-button'), '.dictee-flottante')
        if (!autre) return false
    }
    const auto = String(el.getAttribute('autocomplete') || '').toLowerCase()
    if (/username|password|email|tel|one-time-code/.test(auto)) return false
    const max = Number(el.getAttribute('maxlength') || 0)
    if (max > 0 && max < 20) return false
    return true
}

export function installerDicteeGlobale() {
    if (typeof document === 'undefined' || typeof window === 'undefined' || window.__dicteeGlobale) return null
    // <BoutonDictee pour="id-du-champ" /> utilisable dans tous les gabarits.
    Vue.component('BoutonDictee', BoutonDictee)
    const hote = document.createElement('div')
    document.body.appendChild(hote)
    const vm = new Vue({
        data: { champ: null, visible: false, haut: 0, gauche: 0, actif: false, minuteur: null },
        methods: {
            afficher(champ) {
                clearTimeout(this.minuteur)
                this.champ = champ
                this.visible = true
                this.$nextTick(this.positionner)
            },
            planifierMasquage() {
                clearTimeout(this.minuteur)
                this.minuteur = setTimeout(() => {
                    if (this.actif) return
                    const actuel = document.activeElement
                    if (actuel && actuel === this.champ) return
                    this.visible = false
                    this.champ = null
                }, 200)
            },
            positionner() {
                if (!this.visible || !this.champ || !this.champ.getBoundingClientRect) return
                if (!document.body.contains(this.champ)) { if (!this.actif) this.visible = false; return }
                const zone = this.champ.getBoundingClientRect()
                const bouton = this.$el && this.$el.getBoundingClientRect ? this.$el.getBoundingClientRect() : { width: 220, height: 34 }
                const largeur = bouton.width || 220, hauteur = bouton.height || 34
                let haut = zone.top - hauteur - 4
                if (haut < 4) haut = zone.bottom + 4
                this.haut = Math.round(haut)
                this.gauche = Math.round(Math.max(4, Math.min(window.innerWidth - largeur - 4, zone.right - largeur)))
            },
        },
        render(h) {
            if (!this.visible || !this.champ) return h('div', { style: { display: 'none' } })
            return h('div', { class: 'dictee-flottante', style: { position: 'fixed', top: this.haut + 'px', left: this.gauche + 'px', zIndex: 2000 } }, [
                h(BoutonDictee, { props: { cible: () => this.champ, flottant: true },
                    on: { etat: actif => { this.actif = actif; if (!actif) this.planifierMasquage() } } }),
            ])
        },
    }).$mount(hote)

    document.addEventListener('focusin', evt => {
        if (vm.actif) return
        const el = evt.target
        if (champEligible(el)) vm.afficher(el)
        else if (!plusProche(el, '.dictee-flottante')) vm.planifierMasquage()
    })
    document.addEventListener('focusout', () => { if (!vm.actif) vm.planifierMasquage() })
    window.addEventListener('scroll', () => vm.positionner(), true)
    window.addEventListener('resize', () => vm.positionner())
    window.__dicteeGlobale = vm
    return vm
}
